import { render, staticRenderFns } from "./RegistrationModal.vue?vue&type=template&id=3ccf42e2&scoped=true"
import script from "./RegistrationModal.vue?vue&type=script&lang=js"
export * from "./RegistrationModal.vue?vue&type=script&lang=js"
import style0 from "./RegistrationModal.vue?vue&type=style&index=0&id=3ccf42e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ccf42e2",
  null
  
)

export default component.exports